module.exports = __webpack_public_path__ + "1188ad54dc7e111805f87f8babc3fc9c.jpg";